@if (owners?.length > 0) {
  <table class="w-full mt-4">
    <thead class="text-left border-b border-gray-300/50">
      <th class="w-1/2">Majitel</th>
      <th class="w-1/6">Datum nabytí</th>
      <th class="w-1/6">Inv. číslo</th>
      <th class="w-1/6">Typ majitele</th>
    </thead>
    <tbody>
      @for (owner of sortedData; track owner; let last = $last) {
        <tr
          [ngClass]="{ 'border-b border-gray-300/80': !last }"
          >
          <td class="py-2 font-medium">
            <i>{{ ownerService.parseOwnerTitle(owner, "type") }}</i>
          </td>
          <td class="py-2">
            @if (ownerService.getYearOfPurchase(owner); as year) {
              <span
                [matTooltip]="year.tooltip"
                >{{ year.label }}</span
                >
              }
            </td>
            <td class="py-2">
              {{ owner.ownerItemId }}
            </td>
            <td class="py-2">
              {{ owner.ownerType ? owner.ownerType.title : "Chyba zobrazení" }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
